import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Wrapper, WrappContent, Image, Title, Text, StepNumber } from './styled';

class StepElement extends Component {
    render() {
        const { step, img, title, text, shift } = this.props;
        const alignSelf = shift ? 'flex-end' : 'flex-start';
        let top = 0;
        if (step % 3 === 0) {
 top = 205 * 2;
}
        if (step % 3 === 2) {
 top = 205;
}
        return (
            <Wrapper top={top} alignSelf={alignSelf}>
                <Image src={img} />
                <WrappContent>
                    <StepNumber>
                        Шаг {step}
                    </StepNumber>
                    <Title>
                        {title}
                    </Title>
                    <Text>
                        {text}
                    </Text>
                </WrappContent>
            </Wrapper>
        );
    }
}

export default StepElement;

StepElement.propTypes = {
    step: PropTypes.number,
    img: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
    shift: PropTypes.bool,
    alignSelf: PropTypes.string,
    top: PropTypes.number,
};
